import { Link } from 'react-router-dom';  
import paths from '../../routes/paths';  
import ShippingPolicyImage from '../../assets/images/india-map.png'
import MetaTags from '../Common/MetaTags';

const  ShippingPolicy = () => {   
    return (
      <>
        <MetaTags
          title="Shipping Policy | Anuugha Collections"
          description="Learn about our shipping policies, delivery times, and charges. At Anuugha Collections, we ensure timely and secure deliveries."
          url="https://www.anuughacollections.com/shipping-policy"
          image={process.env.REACT_APP_SERVER_URL + ShippingPolicyImage}
          />
        <div className="page-content bg-light">

          <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
            <div className="container">
              <div className="dz-bnr-inr-entry">
                <h1>Shipping Policy</h1>
                <nav aria-label="breadcrumb" className="breadcrumb-row">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                    <li className="breadcrumb-item">Shipping Policy</li>
                  </ul>
                </nav>
              </div>
            </div>	
          </div> 
          <section className="content-inner">
            <div className="theme-page-section _pv-60 _ph-60 about_one shipping-policy p-t-40 m-b-60">
              <div className="container">
                  <div className="row">
                      <div className="col-md-12">
                          <div className="theme-hero-text theme-hero-text-center">
                              <div className="theme-hero-text-header">
          
                                  <div className="row">
                                      <div className="col-md-4 col-6 text-image">
                                          <img src={ShippingPolicyImage} alt="All over India"/>
                                      </div>
                                      <div className="col-md-8 col-6 text-free-shipping">
                                              <div className="text p-l-60">
                                                  <h2> Shipping All over India</h2>
                                                  <p> From our store to your doorstep. Fast and reliable delivery Nationwide </p> 
                                              </div>
                                      </div>
                                  </div>
                                  <div className="row">
                                      <h3 className="p-t-60 p-b-25">Delivery and shipping policy</h3>
            
                                      <div className="col-md-12">
                                          <h4 className="p-t-30 p-b-20">Shipping policy</h4>
                                          <ul>
                                              <li>Shipping charges on our products shall be mentioned at the time of checkout.  The shipping charges wherever applicable are based on basket size. In cases where the basket size becomes voluminous, we charge a nominal fee as oversized packaging charges, to accommodate and safely deliver all the items ordered.</li>
                                              <li>Customers are requested to provide an accurate, complete and valid address and pin code at the time of creating an account to avoid any delays, as we would not be liable if any incorrect address is provided and no refunds may be claimed by the buyer for any delay in delivery of the Products, which was caused due to reasons beyond our control.</li>
                                              <li>Domestic shipping times typically range from 3 to 10 working days, but it can vary based on factors like the shipping carrier, the distance the package needs to travel, and any potential delays such as holidays or adverse weather conditions. It's always a good idea to check with the specific shipping provider or retailer for more accurate estimates.</li>
                                              <li>Please note that billing Address refers to the address where a customer receives credit card bills and shipping address refers to the address where the order has to be delivered. You cannot change the shipping address once the order is placed.</li>
                                              <li>Once the order is placed, you can track the order status on our website, and in case of any queries relating to the order, our customer care service is available on all the weekdays between 10.00am to 6.00 pm IST. Or you can email your query to anuughacollections@gmail.com or whatsapp 8499919988. After the product is dispatched by us, you will receive the tracking code, with which you can track the status of your purchased product.</li>
                                              <li>For international customers, please whatsapp +91 8499919988 for orders or deliveries or any other queries.</li>
                                              <li>All prices are inclusive of GST.</li>
                                              <li>We disclaim our liability in case of any delay in the delivery due to unforeseen events or wrong delivery address provided by the buyers.</li>
                                              <li>Custom charges might be applicable in case of delivery outside India. Customer will be liable to customs charges in such cases.</li>
                                          </ul>
                                      </div>
                                      
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </section>
  
    
        </div>
      </> 
    );
}

export default ShippingPolicy;

 
